<template>
  <navigation />

  <promo-header />

  <section class="section section-blue">

      <div class="container">

          <h2 class="mb-4">
              {{ page.title }}
          </h2>

          <div v-html="page.content" />

      </div>

  </section>

  <site-footer />
</template>

<script>
import Navigation from "../partials/Navigation.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import SiteFooter from "../partials/SiteFooter.vue";

export default {
    name: "Page",

    components: {
      SiteFooter,
      PromoHeader,
      Navigation,
    },

    data() {
        return {
            page: {},
        };
    },

    mounted() {
        axios({
            method: "get",
            url: `/page/${this.$route.params.pathMatch[0]}/`,
        })
        .catch(() => {
          window.location.href = "/404";
        })
        .then((response) => {
            this.page = response.data;
        });
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.page.title || '404'}`,
        };
    },
};
</script>

